/** Canonical in-app brand mark — same asset as favicon / PWA icons in public/. */
export const BRAND_LOGO_URL = '/favicon.png?v=2'
